// extracted by mini-css-extract-plugin
module.exports = {"serviceRequestCell":"FNOLClaimSummaryComponent_AX_serviceRequestCell__FQ52m"};